// extracted by mini-css-extract-plugin
export var borderWhite = "SearchInput-module--borderWhite--b5524";
export var colorWhite = "SearchInput-module--colorWhite--f6483";
export var disabled = "SearchInput-module--disabled--a1b59";
export var searchWrapper = "SearchInput-module--searchWrapper--9b970";